import { Col, Divider, Row, Tabs } from 'antd';

import { EligibleOffers } from './ContributedOffers/EligibleOffers';
import { AuditTrail } from './AuditTrail';
import { Comments } from './Comments';
import { ContributedOffers } from './ContributedOffers';
import { FrequencyCaps } from './FrequencyCaps';
import { Matching } from './Matching';
import { OCR } from './OCR';
import { Transactions } from './Transactions';

import { setActiveTabAction, snapStore } from '../../store';

export const SnapTabs = () => {
  const activeTabKey = snapStore((state) => state.activeTabKey);

  return (
    <Row className='mb-7'>
      <Col xs={24}>
        <Tabs
          destroyInactiveTabPane
          size='large'
          activeKey={activeTabKey}
          onChange={setActiveTabAction}
          items={[{
            key: '1',
            label: '1. OCR',
            children: <OCR />,
          }, {
            key: '2',
            label: '2. Matching',
            children: <Matching />,
          }, {
            key: '3',
            label: '3. Transactions',
            children: <Transactions />,
          }, {
            key: '4',
            label: '4. Frequency Caps',
            children: <FrequencyCaps />,
          }, {
            key: '5',
            label: '5. Contributed Offers',
            children: (
              <>
                <ContributedOffers />

                <Divider />

                <EligibleOffers />
              </>
            ),
          }, {
            key: '6',
            label: '6. Audit Trail',
            children: <AuditTrail />,
          }, {
            key: '7',
            label: '7. Comments',
            children: <Comments />,
          }]}
        />
      </Col>
    </Row>
  );
};
